import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TableCaptionItem({ labelText, icon, color }) {
  return (
    <>
      <FontAwesomeIcon
        icon={icon}
        size="sm"
        color={color}
        style={{ marginRight: '3px', marginLeft: '12px' }}
      />
      {labelText}
    </>
  );
}

TableCaptionItem.propTypes = {
  icon: PropTypes.shape().isRequired,
  color: PropTypes.string,
  labelText: PropTypes.string.isRequired,
};

TableCaptionItem.defaultProps = {
  color: null,
};

export default TableCaptionItem;
